import { ConsumableQuantityEstimationThemeSizeConfig } from './types';

const large: ConsumableQuantityEstimationThemeSizeConfig = {
  consumableQuantityEstimation: {},
};

export default large;
